import { render, staticRenderFns } from "./TypingSingleBasic.vue?vue&type=template&id=4d6a0d19&scoped=true&"
import script from "./TypingSingleBasic.vue?vue&type=script&lang=js&"
export * from "./TypingSingleBasic.vue?vue&type=script&lang=js&"
import style0 from "./TypingSingleBasic.vue?vue&type=style&index=0&id=4d6a0d19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6a0d19",
  null
  
)

export default component.exports